'use client';

import { queryOptions, useSuspenseQuery, UseSuspenseQueryResult } from '@tanstack/react-query';
import { summeryInvestmentsOptions } from '../queries/summeryInvestments';
import { SummeryInvestmentsDTO } from '@/types/models';
export function useSummeryInvestments(): UseSuspenseQueryResult<SummeryInvestmentsDTO> {
  return useSuspenseQuery(queryOptions(summeryInvestmentsOptions));
}